declare global {
    interface Window {
      env: any;
    }
  }

window.env = window.env || process.env || {}

export const Base_Url = window.env.REACT_APP_API_BASE_URL

export const App_Language = "EN";
export const App_Version = "1.0.0";
export default {
    login: 'auth/login',
    signup:'auth/signup',
    confirmSignup: 'auth/confirm',
    forgotPassword: 'auth/forgotpassword/{email}',
    verify: 'verify-forgot-password-otp',
    resetPassword: 'auth/resetpassword',
    logout: 'logout',

    // user
    user: 'user',
    changePassword: 'user/password',

    // score
    scores: 'award-scoring/all',
    score: 'score',

    // Entries
    entries: 'award-entries',
    entry: 'award-entry/preview',
    deleteEntry: 'award-entry',
    developmentEntry: 'award-entry/development',
    developerEntry: 'award-entry/developer',
    awardQuestions: 'award-questions',
    entryValidate: 'award-entries/validate',
    addProject: 'award-entry/developer/project',
    // developmentQuestions: 'award-questions/development',
    // developerQuestions: 'award-questions/developer',
    prevEntry: 'award-entries/prev',
    shortEntry: 'award-entries',
    shortEntries: 'award-entries?shortlisted=true',
    answers: 'award-entry/answer',
    awardSubmission: 'award-entry/submission',
    questions: 'award-questions/developer',
    //projectProfile: 'award-entry/project-profile',
    projectProfile: 'project/userprofile',
    projectQuestions: 'award-questions',
    // projectProfile: 'award--entry/project-profile',
    uploadImage: 'award-entry/answer/media',

    shortlistCsv: 'award-entry/shortlist/csv',
    
    // common
    countries: 'award-countries',
    cities: 'locations',
    awardCategories: 'award-categories',
    nondeveloperAwardCategories: "award-categories/nondeveloper",
    entryCategories: "award-entry/categories",
    development: '/development',
    loactions:'award-locations',
    anyLocation: 'award-locations/any',
    users:'users',
    awardCriteria:'award-criteria',
    greenType:'green-type',
    residential:'residential-type',
    homePageContent: 'admin/content',
    awardcurrencies: 'award-currencies',
    awardMeasurements: 'award-measurements',
    getAwardTypes: 'awards',
    getGrandFinalAwardCategories: 'awards/award-category',
    getGrandFinalCategories: '/grand-final',
    reuseEntry: '/award-entry/reuse'
}